import styled from 'styled-components';

import style from '../../../../../style';
import { Variant } from '../../types';
import {
  StyledParagraph as ItemStyledParagraph,
  Wrapper as ItemWrapper,
} from '../Item/Item.styled';

interface WrapperProps {
  $variant: Variant;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { size, color }, $variant }) => ({
    display: 'flex',
    justifyContent: 'center',
    width: $variant === Variant.MEDIUM ? size.units(3) : size.units(4),
    cursor: 'pointer',

    [ItemWrapper]: {
      minWidth: 0,
    },

    ...style.mixins.devices.desktop({
      '&:hover': {
        [ItemStyledParagraph]: {
          color: color.content.secondary.hover(),
        },
      },
    }),
  }),
);
